import React, { CSSProperties, ReactNode } from 'react'

import cn from 'classnames'

import classes from './ContentWrapper.module.scss'
import colorsJson from '../../colors.json'

const { colors } = colorsJson

interface ContentWrapperProps {
  noPadding?: boolean
  isFullWidth?: boolean
  bgColor?: keyof typeof colors
  children?: ReactNode
  id?: string
  style?: CSSProperties
  className?: string
  isMain?: boolean
  dataTestId?: string
}

export const getBgColorClass = (bgColor?: string) => {
  if (bgColor) {
    const key = bgColor.replaceAll('/', '').replace('UI', 'Ui')
    return classes[`backgroundColour${key}`]
  }
  return ''
}

const ContentWrapper = (wrapperProps: ContentWrapperProps) => {
  const {
    children,
    noPadding,
    isFullWidth,
    bgColor,
    className,
    isMain = false,
    ...props
  } = wrapperProps

  const contentWrapperProps = {
    className: cn(
      classes.contentWrapper,
      {
        [classes.contentWrapperPadding]: !noPadding,
        [classes.contentWrapperFullwidth]: isFullWidth,
      },
      getBgColorClass(bgColor),
      className
    ),
    ...props,
  }

  return isMain ? (
    <div className={classes.mainContentWrapper}>
      <main {...contentWrapperProps}>{children}</main>
    </div>
  ) : (
    <div {...contentWrapperProps}>{children}</div>
  )
}
export default ContentWrapper
